import { GoogleMapsMarkerClusterer } from "@react-google-maps/api";
import { clusterSize, clusterSvg, clusterTotal } from "lib/map";

// Draws the pins of the Map page and groups them by zoom. Plain Google Maps objects, no React:
// the page creates them in an effect and removes them again in its cleanup.
//
// The clustering code is @googlemaps/markerclusterer, which @react-google-maps/api already
// ships and re-exports, so no extra library is needed.

// Symbol of a cluster: a round badge with the NUMBER OF LOCATIONS in it. That is not the number
// of pins: a pin can stand for several locations that share one address (`locationCount`).
const clusterRenderer = {
  render: (cluster) => {
    const maps = window.google.maps
    const total = clusterTotal(cluster.markers)
    const size = clusterSize(total)
    return new maps.Marker({
      position: cluster.position,
      icon: {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(clusterSvg(size)),
        scaledSize: new maps.Size(size, size),
        anchor: new maps.Point(size / 2, size / 2),
      },
      label: { text: String(total), color: "#ffffff", fontSize: "13px", fontWeight: "700" },
      zIndex: 1000 + total,
    })
  },
}

// Pins for `groups` (see groupByPosition) on `map`, clustered. `onSelect(groupKey)` is called
// when a single pin is clicked. Returns a function that removes everything again.
export const addClusteredPins = (map, groups, onSelect) => {
  const maps = window.google.maps
  const { MarkerClusterer, SuperClusterAlgorithm } = GoogleMapsMarkerClusterer

  const markers = groups.map((group) => {
    const marker = new maps.Marker({
      position: group.position,
      title: group.names.filter(Boolean).join(" / "),
    })
    marker.set("locationCount", group.ids.length)
    marker.addListener("click", () => onSelect(group.key))
    return marker
  })

  // Pins closer than `radius` px are joined up to zoom 15; from zoom 16 on nothing is joined
  const clusterer = new MarkerClusterer({
    map,
    markers,
    algorithm: new SuperClusterAlgorithm({ radius: 70, maxZoom: 15 }),
    renderer: clusterRenderer,
  })

  return () => {
    clusterer.clearMarkers()
    clusterer.setMap(null)
    markers.forEach((marker) => {
      maps.event.clearInstanceListeners(marker)
      marker.setMap(null)
    })
  }
}
